import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import truncateString from '../../../shared/truncate-string';

const Paragraph = styled.p`
  margin-top: 16px;
  margin-bottom: 0;
`;

export default function Blurb() {
  const { isOnWireSide, profile } = React.useContext(ThemeContext);

  if (isOnWireSide || !profile.blurb) {
    return null;
  }

  return (
    <Paragraph>
      {truncateString(profile.blurb, 250, { separator: ' ' })}
    </Paragraph>
  );
}
